import React, { useState } from 'react'
import { PersonAvatar } from './PersonAvatar'

interface TeamMemberProps {
  name: string
  avatarUrl?: string
  isActive?: boolean
  avatarBg: string
  avatarStrokeColor: string
  shadow: string
  onClick?: () => void
}

export function TeamMember({
  name,
  avatarUrl,
  isActive = false,
  avatarBg,
  avatarStrokeColor,
  shadow,
  onClick,
}: TeamMemberProps) {
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  const shouldShowShadow = isActive || isHovered
  return (
    <div
      className={`overflow-hidden h-fit w-24 lg:w-[140px] bg-white cursor-pointer flex flex-col items-center gap-6 py-5 
      ${shouldShowShadow
          ? `rounded-[12px] border-[0.8px] border-[rgba(123,131,235,0.2)] ${shadow}`
          : ''
        } 
      `}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <PersonAvatar
        name={name}
        avatarUrl={avatarUrl}
        avatarBg={avatarBg}
        avatarStrokeColor={avatarStrokeColor}
        avatarStrokeRotate='-rotate-[75deg]'
      />
      <p
        className={`text-center text-xs lg:text-base px-2 leading-normal lg:leading-6 font-medium tracking-wide w-full text-wrap ${isActive ? avatarStrokeColor : 'text-[#122D5C]'
          } `}
      >
        {name.split(' ').map((word, index) => (
          <span key={index} className="block">
            {word}
          </span>
        ))}
      </p>
    </div>
  )
}
